import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  GenderEqualityScoreLabel,
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdGenderEqualityRank extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    activeGrouping: PropTypes.string,
    fieldName:PropTypes.string

  }
  //
  constructor(props) {
    super(props)
    //
    let grpLbl = ''
    switch (props.activeGrouping) {
      case 'rank':
        grpLbl = 'gef_rank'
        break
      case 'peer':
        grpLbl = 'gef_peer'
        break
      default:  // 'group'
        grpLbl = 'gef_grp'
        break
    }
    //
    this.state = {
      grpLbl
    }
  }
  //
  render() {
    return <td
      styleName='col'
      onClick={() => { this.props.clickShareclass(this.props.shareclass) }}
    >
      <GenderEqualityScoreLabel
        fund={this.props.shareclass}
        gefType={this.props.fieldName==='gef_grp_norm'?this.state.grpLbl:this.props.fieldName}
      />
    </td>
  }
}
